import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { forgotPasswordAPI } from 'actions/SecurityUserAssignment/SecurityUserAssignmentAction';
import { useDispatch } from 'react-redux';
import loader from '../../assets/img/loader.svg'

const ForgetPasswordForm = () => {
  const [userId, setUserId] = useState('');
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setIsLoading(true);
      dispatch(
        forgotPasswordAPI(
          userId,
          (response) => {
            setIsLoading(false)
            setTimeout(() => { navigate('/confirm-mail') }, 1000);
          },
          (err) => {
            toast.error(err.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
            setIsLoading(false)
          }
        )
      );
    
    }
    setValidated(true);
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}
      <Form noValidate validated={validated} className="mt-4" onSubmit={handleSubmit} >
        <Form.Group className="mb-3">
          <Form.Control
            placeholder={'Username, email or phone number'}
            value={userId}
            name="userId"
            maxLength="50"
            onChange={({ target }) => setUserId(target.value)}
            type="text"
            required
          />
          <Form.Control.Feedback type="invalid">
            Please provide username, email or phone number
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Button className="w-100" type="submit">
            Send reset link
          </Button>
        </Form.Group>
      </Form>
    </>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;